<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="title-frontMatter"><span>A thing worth having is a thing worth cheating for.</span></div>
<div class="subtitle-frontMatter">ATTRIBUTED TO W. C. FIELDS</div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466828674_fm02.vue?6fe82384